"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = tslib_1.__importStar(require("../.."));
var SSPContentFieldAccessor_1 = tslib_1.__importDefault(require("./SSPContentFieldAccessor"));
var SSPFilePropertiesAccessor_1 = tslib_1.__importDefault(require("./SSPFilePropertiesAccessor"));
var TypedObjectAccessor_1 = tslib_1.__importDefault(require("./TypedObjectAccessor"));
var SSPAssetDataSetAccessor = (function () {
    function SSPAssetDataSetAccessor(model) {
        this._posterFileProperties = null;
        this._metadata = null;
        this._model = model;
        this._acc = new TypedObjectAccessor_1.default();
        this._acc.target = this._model._acc.obj('AssetDataSet');
        this._assetFileProperties = new SSPFilePropertiesAccessor_1.default(this._acc.obj('AssetFileProperties'));
        this.update(model);
    }
    SSPAssetDataSetAccessor.prototype.update = function (model) {
        this._model = model;
        this._acc.target = this._model._acc.obj('AssetDataSet');
        if (this._assetFileProperties) {
            this._assetFileProperties.target = this._acc.obj('AssetFileProperties');
        }
        if (this._posterFileProperties) {
            this._posterFileProperties.target = this._acc.obj('PosterFileProperties');
        }
        if (this._metadata) {
            this._metadata.update(this._model);
        }
    };
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "fileFamily", {
        get: function () {
            return this._acc.str('AssetFileFamily');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "url", {
        get: function () {
            return __1.default.instance.getAssetUrl(this._assetFileProperties.fileHash);
        },
        enumerable: false,
        configurable: true
    });
    SSPAssetDataSetAccessor.prototype.thumbUrl = function (width, height, scalemode) {
        if (scalemode === void 0) { scalemode = __1.SSPScalemode.FIT; }
        return __1.default.instance.getThumbUrl(this._model.uid, width, height, scalemode);
    };
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "fileProperties", {
        get: function () {
            return this._assetFileProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "posterFileProperties", {
        get: function () {
            if (!this._posterFileProperties) {
                this._posterFileProperties = new SSPFilePropertiesAccessor_1.default(this._acc.obj('PosterFileProperties'));
            }
            return this._posterFileProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "posterUrl", {
        get: function () {
            return __1.default.instance.getAssetUrl(this.posterFileProperties.fileHash);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "posterFileExists", {
        get: function () {
            return this.posterFileProperties.fileHash !== '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPAssetDataSetAccessor.prototype, "metadata", {
        get: function () {
            if (!this._metadata) {
                this._metadata = new SSPContentFieldAccessor_1.default(this._model);
            }
            return this._metadata;
        },
        enumerable: false,
        configurable: true
    });
    return SSPAssetDataSetAccessor;
}());
exports.default = SSPAssetDataSetAccessor;
